<app-z-dialog
  [title]="data.title | transloco"
  [contentTemplate]="contentTemplate"
  [actionButtonsTemplate]="buttonsTemplate"
>
</app-z-dialog>

<ng-template #contentTemplate>
  <app-form-grid
    *ngIf="data.fields?.length"
    [inputs]="data.fields"
    [formGroupRef]="formGroup"
  ></app-form-grid>
</ng-template>
<ng-template #buttonsTemplate>
  <z-button
    icon="file_copy"
    [label]="data.actionButton | transloco"
    (clicked)="filter()"
    [disabled]="formGroup.invalid"
  ></z-button>
</ng-template>
